import React from 'react';
import AdminReportesPacsBalanceListManager from './components/AdminReportesPacsBalanceListManager';

const AdminReportesPacsBalance = () => {
  return <AdminReportesPacsBalanceListManager />;
};

export default AdminReportesPacsBalance;
